"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var bibtex_1 = require("bibtex");
var AuthorComponent = function (_a) {
    var author = _a.author;
    var names = [];
    if (author.firstNames.length > 0)
        names.push(React.createElement("tr", { key: "firstNames" },
            React.createElement("td", null, "First names"),
            React.createElement("td", null,
                author.firstNames.map(function (n, i) {
                    return React.createElement("span", { key: i, className: "author-firstName" }, n);
                }),
                " (",
                author.initials.map(function (n, i) {
                    return React.createElement("span", { key: i, className: "author-initial" }, n);
                }),
                ")")));
    if (author.vons.length > 0)
        names.push(React.createElement("tr", { key: "vons" },
            React.createElement("td", null, "von"),
            React.createElement("td", null, author.vons.map(function (n, i) {
                return React.createElement("span", { key: i, className: "author-von" }, n);
            }))));
    if (author.lastNames.length > 0)
        names.push(React.createElement("tr", { key: "lastNames" },
            React.createElement("td", null, "Last names"),
            React.createElement("td", null, author.lastNames.map(function (n, i) {
                return React.createElement("span", { key: i, className: "author-lastName" }, n);
            }))));
    if (author.jrs.length > 0)
        names.push(React.createElement("tr", { key: "jrs" },
            React.createElement("td", null, "Jr"),
            React.createElement("td", null, author.jrs.map(function (n, i) {
                return React.createElement("span", { key: i, className: "author-jr" }, n);
            }))));
    return React.createElement("div", { className: "author-names" },
        React.createElement("div", { className: "author-id" }, author.id),
        React.createElement("table", null,
            React.createElement("tbody", null, names)));
};
var ValueCell = function (_a) {
    var entry = _a.entry;
    if (bibtex_1.isAuthors(entry)) {
        return React.createElement("td", { className: "field-value" },
            React.createElement("ul", null, entry.authors$
                .map(function (a, i) { return React.createElement("li", { key: i }, React.createElement(AuthorComponent, { author: a })); })));
    }
    else {
        var newVar = "";
        if (bibtex_1.isBibStringComponent(entry))
            newVar = bibtex_1.toStringBibStringData(entry.data);
        else
            newVar = entry + "";
        return React.createElement("td", { className: "field-value" }, newVar);
    }
};
var BibEntryComponent = function (_a) {
    var entry = _a.entry;
    return React.createElement("div", { className: "bib-entry" },
        React.createElement("div", { className: "id" }, entry._id),
        React.createElement("table", null,
            React.createElement("tbody", null, Object.keys(entry.fields).map(function (fieldName, i) { return React.createElement("tr", { key: i },
                React.createElement("td", { className: "field-name" }, fieldName),
                React.createElement(ValueCell, { entry: entry.fields[fieldName] })); }))));
};
function renderEntry(entry) {
    if (bibtex_1.isBibEntry(entry))
        return React.createElement(BibEntryComponent, { entry: entry });
    if (bibtex_1.isPreamble(entry))
        return React.createElement("div", { className: "bib-string" });
    if (bibtex_1.isBibComment(entry))
        return React.createElement("div", { className: "bib-comment" });
    console.error("Unknown entry: ");
    console.error(entry);
    return React.createElement("div", null, "???");
}
exports.BibFileComponent = function (_a) {
    var bib = _a.bib;
    return React.createElement("div", { className: "bibfile" },
        React.createElement("ul", { className: "biblist" }, Object.keys(bib.entries$).map(function (entry, i) { return React.createElement("li", { key: i }, renderEntry(bib.getEntry(entry))); })));
};



//////////////////
// WEBPACK FOOTER
// ./src/ts/components/BibFile.tsx
// module id = 81
// module chunks = 0